// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Tanzania from '../_raw/flag/icon_flag_tanzania.png';

export default () => <img src={Tanzania} alt="Tanzania" />;
